import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/pages/ForgotPassword";
import { Loader2 } from "lucide-react";
import api, { readError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function RecoveryUse() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState("");
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing recovery token.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/recovery/use", { token });
        await loginWithToken(data.access_token);
        navigate("/admin/2fa-setup?forced=1", { replace: true });
      } catch (err) {
        setError(readError(err, "Recovery link is invalid or expired."));
      }
    })();
  }, [params, navigate, loginWithToken]);

  return (
    <AuthShell title="Recovering access…">
      {error ? (
        <div data-testid="recovery-use-error" className="text-sm rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2 text-destructive">
          {error}
        </div>
      ) : (
        <div data-testid="recovery-use-loading" className="flex items-center gap-3 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          Verifying your recovery link…
        </div>
      )}
    </AuthShell>
  );
}
